"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardKpiExecution = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var useKpiData_1 = require("./useKpiData");
var utils_1 = require("../utils");
/**
 * Hook allowing to get execution for particular kpi widget.
 * @param config - configuration of the hook
 * @internal
 */
function useDashboardKpiExecution(config) {
    var backend = config.backend, workspace = config.workspace;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useDashboardKpiExecution");
    utils_1.workspaceInvariant(effectiveWorkspace, "useDashboardKpiExecution");
    var _a = useKpiData_1.useKpiData(config), result = _a.result, status = _a.status, error = _a.error;
    var execution = sdk_ui_1.useExecution({
        seriesBy: compact_1.default([result === null || result === void 0 ? void 0 : result.primaryMeasure, result === null || result === void 0 ? void 0 : result.secondaryMeasure]),
        filters: result === null || result === void 0 ? void 0 : result.effectiveFilters,
        backend: effectiveBackend,
        workspace: effectiveWorkspace,
    });
    switch (status) {
        case "pending":
        case "loading": {
            return { status: status, result: undefined, error: undefined };
        }
        case "error":
            return { status: status, result: undefined, error: error };
        case "success": {
            return { status: status, result: execution, error: undefined };
        }
        default: {
            var unhandledStatus = status;
            throw new sdk_backend_spi_1.UnexpectedError("Unhandled status: " + unhandledStatus);
        }
    }
}
exports.useDashboardKpiExecution = useDashboardKpiExecution;
//# sourceMappingURL=useDashboardKpiExecution.js.map